import { createSelector } from "reselect";

import { RootState } from "../store";
import { BillingPaymentPeriod } from "../types/billings";
import { Status } from "../types/state";

export const getCollectionPoint = (state: RootState) => state.collectionPoint;
export const getCollectionPointStatus = (state: RootState) => state.collectionPoint.status;
export const getIsCollectionPointStatusLoading = (state: RootState) => state.collectionPoint.status !== Status.success;

export const getCollectionPointIsUpdating = (state: RootState) => state.collectionPoint.isUpdating;

export const getCollectionPointDetail = (state: RootState) => state.collectionPoint.collectionPoint;

export const getCollectionPointContainers = (state: RootState) => state.collectionPoint.collectionPoint.containers;
export const getCollectionPointPagination = (state: RootState) => state.collectionPoint.pagination;
export const getCollectionPointDetailScrollTop = (state: RootState) => state.collectionPoint.scrollTop;

export const getCollectionPointPaymentSchedule = (state: RootState) =>
  state.collectionPoint.collectionPoint.paymentSchedule;

export const getCollectionPointPaymentScheduleType = (state: RootState) =>
  state.collectionPoint.collectionPoint.paymentSchedule?.type ?? null;
export const getCollectionPointBillingStatus = (state: RootState) =>
  state.collectionPoint.collectionPoint.billingStatus;
export const getBillingPayments = (state: RootState) => state.collectionPoint.collectionPoint.payments;
export const getCollectionPointBillingAnnualPayment = createSelector(
  [getBillingPayments],
  (payments) => payments?.find((payment) => payment.period === BillingPaymentPeriod.Annual) ?? null
);
export const getCollectionPointBillingQuarterlyPayments = createSelector(
  [getBillingPayments],
  (payments) => payments?.filter((payment) => payment.period !== BillingPaymentPeriod.Annual) ?? []
);
export const getCollectionPointBilling = (state: RootState) => state.collectionPoint.collectionPoint.billing;
export const getCollectionPointBillingPaymentSchedule = (state: RootState) =>
  state.collectionPoint.collectionPoint.paymentSchedule;
export const getCollectionPointBillingRefunds = (state: RootState) => state.collectionPoint.collectionPoint.refunds;
